import { Component } from '@angular/core';
import { FadeInReveal } from '../../../directives/fade-in-reveal';
import { BottomTransitionReveal } from '../../../directives/bottom-transition-reveal';

@Component({
  selector: 'app-workspace',
  imports: [
    FadeInReveal,
    BottomTransitionReveal
  ],
  templateUrl: './workspace.html',
  styleUrl: './workspace.less'
})
export class Workspace {

}
